import { Text } from '@chakra-ui/react'

import { DIRECT, UNIVERSITY } from '../../enums/clientType'
import { calculateDiscount } from '../_utils'

const VoucherSuccess = ({ isSuccess, voucher, clientType, amount }) => {
    const _renderVoucherSuccessText = _voucher => {
        let successText = ''
        if (clientType === DIRECT) {
            let discount = calculateDiscount(_voucher, amount)

            successText = `Coupon code successfully applied. You saved ₹ ${parseFloat(
                discount / 100
            )}.`
        } else if (clientType === UNIVERSITY) {
            successText = 'Test code verified successfully'
        }

        return successText
    }

    return (
        isSuccess && (
            <Text
                fontSize={'sm'}
                mt={6}
                color="fruitsalad"
                fontStyle={'italic'}
            >
                {_renderVoucherSuccessText(voucher)}
            </Text>
        )
    )
}

export default VoucherSuccess
